<template>
  <div class="feedback">
    <div class="item-li2">
      <div class="item-t1">请填写问题描述</div>
      <div class="item-t2">
        <textarea
          class="item-textarea"
          placeholder="请在此输入你的宝贵意见"
          max="500"
        ></textarea>
        <i class="item-i">0/500</i>
      </div>
      <div class="item-t3">图片说明（最多6张）</div>
      <div class="item-box">
        <ul class="img-list">
          <li class="img-li" v-for="item in list" :key="item">
            <img class="img1" src="../assets/img/img01.png" alt="imgli" />
            <img
              @click="delImg(item)"
              class="img2"
              src="../assets/img/icon-delete.png"
              alt="icon-delete"
            />
          </li>
          <li class="loadimg" @click="add">
            <img src="../assets/img/icon_add.png" alt="add" />
          </li>
        </ul>
      </div>
    </div>
    <div class="item-li3">
      <a class="item-submit">提交</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feedback',
  data() {
    return {
      list: [0]
    };
  },
  methods: {
    add() {
      if (this.list.length < 6) {
        this.list.push(this.list.length);
      }
    },
    delImg(item) {
      this.list.splice(item, 1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feedback {
  height: 100%;
  background: #f8f8f8;
  font-size: 30px;
  color: #06112a;
}
.item-li2 {
  width: 100%;
  background-color: #fff;
  padding: 0 30px;
}
/* .item-li{
      display:flex;
      box-sizing:border-box;
      height: 100px;
      line-height:100px;
      position:relative;  
   } */
.item-li2 {
  height: 1158px;
}
.mt20 {
  margin-top: 20px;
}
.mt32 {
  margin-top: 32px;
}
.mt14 {
  margin-top: 14px;
}
.item-left {
  flex: 1;
}
.item-right {
  flex: 1;
  text-align: right;
  color: #8d939c;
  padding-right: 34px;
}
.item-to {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
}
.item-t1 {
  padding-top: 28px;
  line-height: 30px;
}
.item-t2 {
  width: 100%;
  height: 280px;
  margin-top: 32px;
  padding: 24px 8px 24px 24px;
  background-color: #f8f8f8;
  overflow: hidden;
  position: relative;
}
.item-textarea,
.item-i {
  color: #babcc5;
}
input::placeholder {
  color: #babcc5;
}
.item-textarea {
  width: 100%;
  height: 280px;
  outline: 0;
  font-size: 28px;
  line-height: 36px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-user-modify: read-write-plaintext-only;
  border: 0;
  background-color: transparent;
  font-weight: 500;
}
.item-i {
  position: absolute;
  bottom: 20px;
  right: 24px;
}
.item-t3 {
  margin-top: 48px;
  line-height: 30px;
}
.item-li3,
.item-li4 {
  padding: 0 32px;
}
.item-li3 {
  border-top: 1px solid #e5e5e5;
  height: 176px;
  padding-top: 14px;
  background-color: #fff;
}
.item-box {
  display: flex;
  margin: 32px 0;
}
.img-list {
  display: flex;
  flex-wrap: wrap;
}
.img-li,
.loadimg,
.img1,
.loadimg img {
  width: 136px;
  height: 136px;
}
.img-li {
  position: relative;
  margin: 0 20px 20px 0;
}
.img1 {
  border-radius: 12px;
}
.img2 {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -16px;
  right: -16px;
}
.img1,
.img2,
.loadimg img {
  display: block;
}

.item-submit {
  /* width: 686px; */
  display: block;
  height: 80px;
  background: linear-gradient(120deg, #fe7d27 0%, #ff660f 100%);
  border-radius: 40px;
  color: #fff;
  line-height: 80px;
  text-align: center;
}
.item-p {
  font-size: 26px;
  font-weight: 500;
  color: #babcc5;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/view/feedback.vue